import { AppState } from "@Store/index";
import { useEffect } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import config from "@Config/index";
import { fetchSearchDataIfNeed, setRadiusExpandEnabled } from "./data/searchPageReducer";
import { RouteComponentProps } from "react-router";

const useSearch = (props: RouteComponentProps) => {
  const { location }: any = props;
  const dispatch = useDispatch();
  const {
    isError,
    showRegionPage,
    isStatus500,
    error,
    showMobileMap,
    isInternalUser,
    showFullPageLoader,
  } = useSelector(
    ({ searchPageData, appData }: AppState) => ({
      isError: searchPageData.readyStatus === "failure",
      isStatus500: !JSON.stringify(searchPageData.error)?.includes("404"),
      error: JSON.stringify(searchPageData.error),
      showRegionPage: ["country", "state"].includes(searchPageData?.region?.region_type),
      showMobileMap: searchPageData?.mobileMapData?.show,
      isInternalUser: appData.isInternalUser,
      showFullPageLoader:
        searchPageData.readyStatus !== "success" || appData?.isLoadingTranslations,
    }),
    shallowEqual,
  );

  useEffect(() => {
    if (isError && isStatus500) {
      if (typeof window !== undefined) {
        window?.Sentry?.captureException(error);
      }
    }
  }, [isError, isStatus500]);

  useEffect(() => {
    dispatch(fetchSearchDataIfNeed(props));
  }, [dispatch, location.pathname, location.search]);

  // Mirror the GrowthBook RADIUS_EXPAND flag into Redux for client-side fetches and UI.
  // SSR treats the flag as enabled via resolveRadiusExpandEnabled (see fetchSearchDataIfNeed).
  // GrowthBook is never initialised in the China build — China stays disabled throughout.
  const isRadiusExpandEnabled = true && !config.IS_CHINA_APP;

  useEffect(() => {
    dispatch(setRadiusExpandEnabled(isRadiusExpandEnabled));
  }, [dispatch, isRadiusExpandEnabled]);

  return {
    isError,
    showRegionPage,
    isStatus500,
    showMobileMap,
    isInternalUser,
    showFullPageLoader,
  };
};

export default useSearch;
